import React from "react";
import { Container, useTheme } from "@mui/material";
import PageContent from "../../components/layout/container/PageContent";
import LegalSection from "./LegalSection";

const TermsAndConditions = () => {
    const theme = useTheme();

    return (
        <PageContent title="Termos e Condições de Serviço">
            <Container maxWidth="md" sx={{ marginTop: theme.spacing(10) }}>

                <LegalSection title="1. Aceitação dos Termos">
                    Ao aceder e utilizar o website da Associação Desportiva e Cultural de Benavente, você concorda em cumprir e ficar vinculado aos seguintes Termos de Serviço.
                    Se não concordar com estes termos, por favor, não utilize o nosso site.
                </LegalSection>

                <LegalSection title="2. Alterações aos Termos">
                    A Associação Desportiva e Cultural de Benavente reserva-se o direito de modificar estes Termos de Serviço a qualquer momento.
                    As alterações entrarão em vigor imediatamente após a sua publicação no site. O uso continuado do site após a publicação das alterações
                    constitui a sua aceitação dos novos termos.
                </LegalSection>
                
                <LegalSection title="3. Utilização do Site">
                    O utilizador concorda em utilizar o site apenas para fins legais e de acordo com os presentes Termos de Serviço. Concorda em não utilizar o site para:
                    <ul>
                        <li>Publicar ou transmitir qualquer conteúdo ilegal, ameaçador, abusivo, difamatório, obsceno ou de qualquer forma censurável.</li>
                        <li>Violar qualquer lei ou regulamento local, nacional ou internacional.</li>
                        <li>Infringir os direitos de propriedade intelectual ou outros direitos de qualquer entidade.</li>
                        <li>Introduzir vírus, malware ou outros códigos maliciosos.</li>
                    </ul>
                </LegalSection>

                <LegalSection title="4. Conteúdo do Utilizador">
                    Ao submeter qualquer conteúdo ao nosso site, você concede à Associação Desportiva e Cultural de Benavente uma licença não exclusiva,
                    gratuita e global para utilizar, reproduzir, modificar, adaptar, publicar e distribuir tal conteúdo em qualquer meio.
                </LegalSection>

                <LegalSection title="5. Propriedade Intelectual">
                    Todos os conteúdos presentes no site, incluindo, mas não se limitando a, textos, imagens, logótipos e gráficos, são propriedade da
                    Associação Desportiva e Cultural de Benavente e estão protegidos pelas leis de direitos de autor e outras leis de propriedade intelectual.
                </LegalSection>

                <LegalSection title="6. Links para Sites de Terceiros">
                    O nosso site pode conter links para sites de terceiros que não são operados ou controlados pela
                    Associação Desportiva e Cultural de Benavente. Não somos responsáveis pelo conteúdo ou práticas de privacidade desses sites.
                    A inclusão de qualquer link não implica a nossa aprovação do site vinculado.
                </LegalSection>

                <LegalSection title="7. Limitação de Responsabilidade">
                    Na medida máxima permitida por lei, a Associação Desportiva e Cultural de Benavente não será responsável por quaisquer danos diretos,
                    indiretos, incidentais, consequenciais ou punitivos resultantes do uso ou incapacidade de usar o site.
                </LegalSection>

                <LegalSection title="8. Indemnização">
                    O utilizador concorda em indemnizar e isentar a Associação Desportiva e Cultural de Benavente, os seus funcionários, diretores, empregados
                    e agentes de quaisquer reivindicações, danos, obrigações, perdas, responsabilidades, custos ou dívidas e despesas (incluindo honorários de advogados)
                    decorrentes de:
                    <ul>
                        <li>Uso e acesso ao site;</li>
                        <li>Violação de qualquer termo destes Termos de Serviço;</li>
                        <li>Violação de quaisquer direitos de terceiros, incluindo qualquer direito de propriedade intelectual ou de privacidade.</li>
                    </ul>
                </LegalSection>

                <LegalSection title="9. Lei Aplicável">
                    Estes Termos de Serviço são regidos e interpretados de acordo com as leis de Portugal.
                    Qualquer disputa decorrente ou relacionada com estes termos estará sujeita à jurisdição exclusiva dos tribunais portugueses.
                </LegalSection>

                <LegalSection title="10. Contacto">
                    Se tiver dúvidas ou preocupações sobre estes Termos de Serviço, por favor, contacte-nos através dos formulários disponíveis no site.
                </LegalSection>

                <LegalSection title="Última Atualização">
                    30 de Julho de 2024
                </LegalSection>

            </Container>
        </PageContent>
    );
}

export default TermsAndConditions;
